export enum QuizResponse {
  Initialize,
  Start,
  Submit,
  Accept,
  Retake,
  Override
}
